import React, {useEffect, useState,} from 'react';
import {Row, Result, Image, Col, Button, Tooltip, Divider} from 'antd';
import {AppstoreOutlined, BarsOutlined} from '@ant-design/icons';
import {collection, query, getDocs, orderBy, where} from "firebase/firestore";
import {firestore} from '../../services/firebase';
import AppLoading from '../../components/AppLoading';
import VideoCard from './VideoCard';
import VideoList from './VideoList';
import '../styles/Home.less';

const Simposio2022 = () => {

  const [videos, setVideos] = useState([]);
  const [videosCat, setVideosCat] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tabActive, setTabActive] = useState(true);
  const [_videosHoy, setVideosHoy] = useState([]);
  const [_videosSiguiente, setVideosSiguiente] = useState([]);


  const GrupoBotones = () => {
    return (
      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}} style={{justifyContent: 'center'}}>
        <Col
          xs={{span: 6, offset: 0}}
          sm={{span: 6, offset: 0}}
          md={{span: 8, offset: 0}}
          lg={{span: 8, offset: 0}}
          xxl={{span: 8, offset: 0}}
          style={{textAlign: 'center'}}
        >
          <Image
            src="/logoXXIII.png"
            placeholder="Poster"
            style={{width: "100%"}}
          />
        </Col>
        <Col
          xs={{span: 6, offset: 0}}
          sm={{span: 6, offset: 0}}
          md={{span: 4, offset: 0}}
          lg={{span: 4, offset: 0}}
          xxl={{span: 4, offset: 0}}
          style={{textAlign: 'center'}}
        >
          <Image
            width={100}
            src="/posterXXIII.jpg"
            placeholder="Poster"/>
          <br/>
          <h3>Poster</h3>
        </Col>

        <Col
          xs={{span: 6, offset: 1}}
          sm={{span: 6, offset: 1}}
          md={{span: 4, offset: 1}}
          lg={{span: 4, offset: 1}}
          xxl={{span: 4, offset: 1}}
          style={{textAlign: 'center'}}
        >
          <a className="btn_link" target="_blank" download href="/programaXXIII.pdf" rel="noreferrer">
            <Image
              width={90}
              src="/programaXXIII.jpg"
              placeholder="Programa"/>
          </a>
          <br/>
          <h3>Programa</h3>
        </Col>

        <Col
          xs={{span: 6, offset: 1}}
          sm={{span: 6, offset: 1}}
          md={{span: 4, offset: 1}}
          lg={{span: 4, offset: 1}}
          xxl={{span: 4, offset: 1}}
          style={{textAlign: 'center'}}
        >
          <a className="btn_link" target="_blank" download href="https://viverosantarita.com/" rel="noreferrer">
            <Image
              preview={false}
              width={140}
              src="/logo-santarita.png"
              placeholder={false}/>
          </a>
          <br/>
        </Col>
      </Row>
    )
  }

  const setTab = () => {
    setTabActive(!tabActive);
  }

  useEffect(() => {
    const getVideos = async () => {
      const q = query(collection(firestore, "videos"), where('anio', "==", '2022'), orderBy("index", "asc"));
      const querySnapshot = await getDocs(q);
      const docs = [];
      querySnapshot.forEach((doc) => {
        // if( doc.data().estatus === 1 ) {
        if (doc.data().estatus === 1 && doc.data().categoria !== 'publicidad') {
          docs.push({...doc.data(), id: doc.id});
        }
      });

      setVideos(docs);
      setLoading(false);
    };

    const getVideosCat = async () => {
      const q = query(collection(firestore, "videos"), where('anio', "==", '2022'), orderBy("index", "asc"));
      const querySnapshot = await getDocs(q);
      const docs = [];

      querySnapshot.forEach((doc) => {
        if (doc.data().estatus === 1 && doc.data().categoria === 'publicidad') {
          docs.push({...doc.data(), id: doc.id});
        }
      });

      docs.sort(function (a, b) {
        if (a.index > b.index) return 1;
        if (a.index < b.index) return -1;
        return 0;
      });
      setVideosCat(docs);
    }

    let mounted = true;
    if (mounted) {
      getVideos();
      getVideosCat();
    }
    return () => {
      mounted = false;
    }
  }, []);

  useEffect(() => {
    const videosHoy = [];
    const videosSiguiente = [];
    for (let i = 0; i < videos.length; i++) {
      let diaVideo = videos[i].horario.toDate().getDate();
      let diaHoy = new Date().getDate();

      if (diaVideo === diaHoy) {
        videosHoy.push(videos[i]);
      }
      ;
      if (diaVideo !== diaHoy) {
        videosSiguiente.push(videos[i]);
      }
      ;
    }
    ;
    setVideosHoy(videosHoy);
    setVideosSiguiente(videosSiguiente);
  }, [videos]);

  if (loading) {
    return <AppLoading/>
  }
  ;

  if (videos.length < 1) {
    return (
      <>
        <Result
          title="Registro completo"
          extra="Los videos estaran próximamente en este portal."
          status="success"
        />
        <GrupoBotones/>
      </>
    );
  }
  return (
    <>
      <GrupoBotones/>

      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        <Col
          xs={{span: 24, offset: 0}}
          sm={{span: 24, offset: 0}}
          md={{span: 24, offset: 0}}
          lg={{span: 24, offset: 0}}
          xxl={{span: 24, offset: 0}}
          style={{marginBottom: 10,}}
        >
          <div className="btn-change-view">
            <Tooltip title='Vista cuadricula'>
              <Button
                disabled={tabActive ? true : false}
                type='primary'
                onClick={setTab}
                icon={<AppstoreOutlined/>}
              />
            </Tooltip>
            <Tooltip title='Vista listado'>
              <Button
                disabled={tabActive ? false : true}
                type='primary'
                onClick={setTab}
                icon={<BarsOutlined/>}
              />
            </Tooltip>
          </div>
        </Col>
      </Row>

      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        {_videosHoy.map((item, index) => (
          tabActive ? <VideoCard key={index} data={item}/> : <VideoList key={index} data={item}/>
        ))}
      </Row>
      <Divider dashed/>
      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        {_videosSiguiente.map((item, index) => (
          tabActive ? <> <VideoCard key={index} data={item}/></> : <VideoList key={index} data={item}/>
        ))}
      </Row>
      <Divider dashed/>
      <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
        {videosCat.map((item, index) => (
          tabActive ? <> <VideoCard key={index} data={item}/> </> : <VideoList key={index} data={item}/>
        ))}
      </Row>
    </>
  )
};

export default Simposio2022;
